var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportMgmt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87988 18.9001C6.46988 18.9001 6.12988 18.5601 6.12988 18.1501V16.0801C6.12988 15.6701 6.46988 15.3301 6.87988 15.3301C7.28988 15.3301 7.62988 15.6701 7.62988 16.0801V18.1501C7.62988 18.5701 7.28988 18.9001 6.87988 18.9001Z",
    fill: "#3A4B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.9C11.59 18.9 11.25 18.56 11.25 18.15V14C11.25 13.59 11.59 13.25 12 13.25C12.41 13.25 12.75 13.59 12.75 14V18.15C12.75 18.57 12.41 18.9 12 18.9Z",
    fill: "#3A4B55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1201 18.9007C16.7101 18.9007 16.3701 18.5607 16.3701 18.1507V11.9307C16.3701 11.5207 16.7101 11.1807 17.1201 11.1807C17.5301 11.1807 17.8701 11.5207 17.8701 11.9307V18.1507C17.8701 18.5707 17.5401 18.9007 17.1201 18.9007Z",
    fill: "#3A4B55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87958 13.1804C6.53958 13.1804 6.23958 12.9504 6.14958 12.6104C6.04958 12.2104 6.28959 11.8004 6.69959 11.7004C10.3796 10.7804 13.6196 8.77041 16.0896 5.90041L16.5496 5.36041C16.8196 5.05041 17.2896 5.01041 17.6096 5.28041C17.9196 5.55041 17.9596 6.02041 17.6896 6.34041L17.2296 6.88041C14.5596 10.0004 11.0396 12.1704 7.05958 13.1604C6.99958 13.1804 6.93958 13.1804 6.87958 13.1804Z",
    fill: "#3A4B55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1204 9.52059C16.7104 9.52059 16.3704 9.18059 16.3704 8.77059V6.60059H14.1904C13.7804 6.60059 13.4404 6.26059 13.4404 5.85059C13.4404 5.44059 13.7804 5.10059 14.1904 5.10059H17.1204C17.5304 5.10059 17.8704 5.44059 17.8704 5.85059V8.78059C17.8704 9.19059 17.5404 9.52059 17.1204 9.52059Z",
    fill: "#3A4B55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#3A4B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportMgmt);
export default __webpack_public_path__ + "static/media/report-mgmt.ef3ced6acaec211c07ce6c23cf0e923a.svg";
export { ForwardRef as ReactComponent };